import { spLogTags, structuredCloneL } from "@eventr/common";
import { createContext, useCallback, useEffect, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { useBoundStore } from "./bound.store";
type IfilterValues = {
  [key: string]: string;
};
interface IFliterContext {
  filteredValues: any;
  filterValues: () => any;
  filterOptions: (searchFilter: string, filterOptions: IfilterValues[]) => string[];
  filterData: (searchFilter: string) => any;
}

const FilterContext = createContext<IFliterContext>({
  filteredValues: {},
  filterValues: () => [],
  filterOptions: () => [],
  filterData: () => {},
});

export const FilterProvider = (props: { children: React.ReactNode }) => {
  const { selectedItinerary, getV2Value } = useBoundStore(
    useShallow((s) => {
      return {
        selectedItinerary: s.selectedItinerary,
        getV2Value: s.getV2Value,
      };
    }),
  );
  const [filteredValues, setFilteredValues] = useState<any>({});

  const filterValues = useCallback(() => {
    if (selectedItinerary?.v2) {
      const valsObj: Record<string, { [key: string]: string }> = {};
      selectedItinerary?.v2.forEach((d) => {
        if (d.data) {
          if (d?.rendererOptions?.settings?.filterCriteria) {
            const id = d.sectionID;
            const key = Object.keys(d.data)[0];
            const filterCriteria = d?.rendererOptions?.settings.filterCriteria;
            const resultArray: { [key: string]: string } = {};
            if (key && d.data[key]) {
              d.data[key].forEach((e: any) => {
                if (filterCriteria && filterCriteria.length > 0) {
                  let results = "";
                  filterCriteria.forEach((f) => {
                    results += getV2Value(f, e).toLowerCase() + ", ";
                  });
                  resultArray[e._id] = results;
                }
              });
            } else {
              if (key) {
                spLogTags("Error data[key]: " + d.sectionID, ["error"]);
                return;
              } else {
                spLogTags("Error with key: " + key + " in section: " + d.sectionID, ["ERROR"]);
                return;
              }
            }

            valsObj[id] = resultArray;
            return { [id]: resultArray };
          }
        }
      });
      return valsObj;
    }
  }, [selectedItinerary, getV2Value]);

  useEffect(() => {
    setFilteredValues(filterValues());
  }, [selectedItinerary, filterValues]);

  //my aim here is to take the information from data provider and filter it
  const filterOptions = (searchFilter: string, filterOptions: IfilterValues[]) => {
    const filteredData: string[] = [];
    filterOptions.forEach((d) => {
      const id = Object.keys(d)[0];
      if (id === undefined) return;
      const data = d[id];
      if (data === undefined) return;
      const added = false;
      if (!added && data.includes(searchFilter.toLowerCase())) {
        filteredData.push(id);
      }
    });

    return filteredData;
  };

  const filterSectionData = (searchFilter: string, section: any) => {
    //section will return data if string exhists insection and undefined if not

    if (filteredValues[section.sectionID]) {
      const stringData = JSON.stringify(section.data).toLowerCase();

      if (searchFilter && stringData.includes(searchFilter)) {
        const sectionID = section.sectionID;
        const id = Object.keys(section.data)[0];
        if (id === undefined) return undefined;
        const y = section.data[id]
          .map((e: any) => {
            if (filteredValues[sectionID][e._id] && filteredValues[sectionID][e._id].includes(searchFilter)) {
              return e;
            } else {
              return undefined;
            }
          })
          .filter((e: any) => e !== undefined);
        section.data[id] = y;
        return section;
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  };

  const filterData = (searchFilter: string, data: any = selectedItinerary?.v2) => {
    if (!data) {
      return;
    }
    data = structuredCloneL(data);
    if (searchFilter === undefined || searchFilter.length <= 1) {
      return data;
    } else {
      return data
        .map((d: any) => {
          return filterSectionData(searchFilter, d);
        })
        .filter((d: any) => d !== undefined);
    }
  };

  return (
    <FilterContext.Provider
      value={{
        filteredValues,
        filterValues,
        filterOptions,
        filterData,
      }}
    >
      {props.children}
    </FilterContext.Provider>
  );
};
